/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_lose = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lose (−500)`)
};

const es_bmr_lose = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perder (−500)`)
};

const de_bmr_lose = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abnehmen (−500)`)
};

const nl_bmr_lose = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afvallen (−500)`)
};

const fr_bmr_lose = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perte (−500)`)
};

const it_bmr_lose = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimagrire (−500)`)
};

const pt_br2_bmr_lose = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emagrecer (−500)`)
};

const pt_bmr_lose = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perder (−500)`)
};

const ja_bmr_lose = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`減量 (−500)`)
};

const zh_bmr_lose = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`减脂（−500）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_lose = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_lose(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_lose", locale)
	if (locale === "en") return en_bmr_lose(inputs)
	if (locale === "es") return es_bmr_lose(inputs)
	if (locale === "de") return de_bmr_lose(inputs)
	if (locale === "nl") return nl_bmr_lose(inputs)
	if (locale === "fr") return fr_bmr_lose(inputs)
	if (locale === "it") return it_bmr_lose(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_lose(inputs)
	if (locale === "pt") return pt_bmr_lose(inputs)
	if (locale === "ja") return ja_bmr_lose(inputs)
	return zh_bmr_lose(inputs)
};